<ion-header>
</ion-header>

<ion-content>
  <div class="container" role="progressbar" tabindex="-1" aria-valuetext="Fetching">
    <div class="overlay">
      <span class="ring2" #ring2></span>
    </div>
    <div class="overlay">
      <span class="ring3" #ring3></span>
    </div>
    <div class="overlay">
      <span class="ring1" #ring1></span>
    </div>
    <div class="logo">
      <span class="pulse-button" #pb>
        <img class="circular-image" src="../../../assets/img/appicon.png">
      </span>
    </div>
  </div>
</ion-content>